import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import AccountAudienceData from "../../PhylloConnectComponents/CommonComponents/AccountAudienceData/AccountAudienceData";
import AccountContentData from "../../PhylloConnectComponents/CommonComponents/AccountContentData/AccountContentData";
import AccountIdentityData from "../../PhylloConnectComponents/CommonComponents/AccountIdentityData/AccountIdentityData";
import AccountNavBar from "../../PhylloConnectComponents/CommonComponents/AccountNavBar/AccountNavBar";
import FullScreenLoader from "../../PhylloConnectComponents/CommonComponents/FullScreenLoader";
import NavBar from "../../PhylloConnectComponents/CommonComponents/NavBar/NavBar";
import PublishPost from "../../PhylloConnectComponents/CommonComponents/PublishPost/PublishPost";
import all_content_icon from "../../assets/images/content_icon.svg";
import { getAllAccounts } from "../../utils/apiHelperInternal";
import {
  onAccountConnectedCallBack,
  onAccountDisconnectedCallBack,
  onTokenExpiredCallBack,
} from "../../utils/callbackFunctions";
import {
  AUDIENCE_SUPPORTED_PLATFORMS,
  PHYLLO_CONNECTED_KEY,
  PHYLLO_POLLING_TIMEOUT,
  PHYLLO_SESSION_EXPIRED,
  PHYLLO_USERID,
} from "../../utils/constants";
import "./Dashboard.scss";

const Dashboard = React.memo(() => {
  const [isAccountsLoading, setIsAccountsLoading] = useState(true);
  const [accountInfo, setAccountInfo] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState();
  const [selectedWorkPlatform, setSelectedWorkPlatform] = useState(null);
  const timeoutId = useRef();

  //const [expireInterval, setExpireInterval] = useState(0);
  const history = useHistory();
  var expireInterval = 0;
  var attempts = useRef();
  const InstagramLiteWorkplatformId = "fb7cafcf-60ed-468a-ad6d-6bb6899d0871";
  const TabValues = {
    insights: "Insights",
    publish: "Publish",
  };
  const [currTab, SetCurrTab] = useState(TabValues.insights);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ padding: "0px" }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const continueClick = async (workPlatformId) => {
    try {
      const clientDisplayName = process.env.REACT_APP_PHYLLO_APP;
      const environment = process.env.REACT_APP_ENV;
      const userId = sessionStorage.getItem("PhylloUserId");
      const token = sessionStorage.getItem("PhylloToken");

      const config = {
        clientDisplayName,
        environment,
        userId,
        token,
      };

      const onExitCallBack = (reason, userId) => {
        console.log(`onExit reason: ${reason}, userId: ${userId}`);
        history.go(0);
        //if (reason === "DONE_CLICKED") {
        //history.go(0);
        //}
      };

      const phylloConnect = window.PhylloConnect.initialize(config);
      phylloConnect.on("exit", onExitCallBack);
      phylloConnect.on("tokenExpired", onTokenExpiredCallBack);
      phylloConnect.on("accountConnected", onAccountConnectedCallBack);
      phylloConnect.on("accountDisconnected", onAccountDisconnectedCallBack);

      phylloConnect.open();
    } catch (err) {
      console.log(err);
    }
  };

  const selectPlatform = (id) => {
    setSelectedPlatform(id);
  };

  const getCleanedData = (val) => {
    if (val === null || val === undefined) {
      return "NA";
    }
    return val;
  };

  const isNull = (val) => {
    if (val === null || val === undefined) {
      return true;
    }

    return false;
  };

  const checkConnections = (accounts) => {
    for (let account = 0; account < accounts.length; account++) {
      if (accounts[account].val.status === PHYLLO_CONNECTED_KEY) return true;
    }
    return false;
  };

  const fetchAccountInfo = async () => {
    const tempAccountArr = [];
    try {
      if (window.location.pathname === "/dashboard") {
        let response = await getAllAccounts(); /// Add success status code -----CA
        response = response.data;
        const data = response.data;
        if (data.length !== 0) {
          data.forEach((element) => {
            if (
              element.status === PHYLLO_CONNECTED_KEY ||
              element.status === PHYLLO_SESSION_EXPIRED
            ) {
              //|| element.status === // add session expired
              const dataFetchStatusObj = {
                isAllDataFetched: false,
                isIdentityFetched: false,
                isIncomeFetched: false,
                isEngagementFetched: false,
              };
              if (element.status === PHYLLO_CONNECTED_KEY)
                tempAccountArr.push({ val: element, dataFetchStatusObj });
            }
            //else if (element.status === PHYLLO_NOT_CONNECTED_KEY) {
            // This is working as continue // will go for next iteration without doing anything
            //return;
            //}
            //else {
            //   setTimeout(fetchAccountInfo(), 3000);
            //   return;
            // }
          });
          //setAccountInfo((prevValue) => [...prevValue, {val : element, isDataFetched : false}])
          //setExpireInterval(new Date().getTime() + parseInt(PHYLLO_POLLING_TIMEOUT))
          expireInterval =
            new Date().getTime() + parseInt(PHYLLO_POLLING_TIMEOUT);
          if (
            tempAccountArr &&
            (tempAccountArr.length < 1 || !checkConnections(tempAccountArr))
          ) {
            history.push("/connect");
            return;
          }
          setAccountInfo(tempAccountArr);
          setIsAccountsLoading(false);
          setSelectedPlatform(tempAccountArr[0].val.id);

          // fetchAccountDetailedInfo(tempAccountArr[0]);
        } else {
          // retryApiLogic(fetchAccountInfo, 5);
          if (attempts.current > 0) {
            attempts.current = attempts.current - 1;
            timeoutId.current = setTimeout(() => {
              fetchAccountInfo();
            }, 6000);
          } else {
            history.push("/connect");
            return;
          }
        }
      }
    } catch (err) {
      // Add some error handler in this ---- CA
      console.log(err);
    }
  };

  useEffect(() => {
    // setIsAccountsLoading(false);
    const userId = sessionStorage.getItem(PHYLLO_USERID);
    // for authorization
    if (!userId) {
      history.push("/");
      return;
    }
    attempts.current = 3;
    fetchAccountInfo();
    // debounceAccounts(debounceAccounts);

    return () => {
      window.clearTimeout(timeoutId.current);
    };
  }, []);

  useEffect(() => {
    if (
      !isAccountsLoading &&
      accountInfo &&
      accountInfo.length > 0 &&
      selectedPlatform
    ) {
      setSelectedWorkPlatform(
        accountInfo.filter((acc) => acc.val.id === selectedPlatform)[0].val
          .work_platform
      );
    }
  }, [selectedPlatform]);

  return (
    <>
      {isAccountsLoading && <FullScreenLoader />}
      {!isAccountsLoading && selectedWorkPlatform && (
        <div className="dashboard-contianer">
          <nav className={"sticky-top"}>
            <NavBar isLoggedIn={true} isLightMode={false} history={history} />
            <div className="account-nav-bar-container">
              <AccountNavBar
                tabValue={currTab}
                setTabValue={SetCurrTab}
                accountInfo={accountInfo}
                selectedPlatform={selectedPlatform}
                setSelectedPlatform={setSelectedPlatform}
                history={history}
              />
            </div>
          </nav>
          <Box className="contents">
            <Box
              sx={{
                background: "#f7f7fb",
                paddingTop: "1px",
                // paddingBottom: "100px",
              }}
            >
              <TabPanel
                className="AccountData"
                index={TabValues.insights}
                value={currTab}
              >
                <AccountIdentityData selectedPlatform={selectedPlatform} />
                {AUDIENCE_SUPPORTED_PLATFORMS.includes(
                  selectedWorkPlatform.name
                ) && (
                  <AccountAudienceData selectedPlatform={selectedPlatform} />
                )}
                <AccountContentData
                  selectedPlatform={selectedPlatform}
                  title={"Your content"}
                  titleIcon={all_content_icon}
                />
              </TabPanel>
              <TabPanel
                className="AccountData"
                index={TabValues.publish}
                value={currTab}
              >
                <PublishPost
                  accountInfo={accountInfo}
                  selectedPlatform={selectedPlatform}
                />
              </TabPanel>
            </Box>
          </Box>
          <div className="footer-container">
            <p className="footer-link">
              © 2023 Phyllo, All rights reserved by Phyllo Inc.
            </p>
          </div>
        </div>
      )}
    </>
  );
});

export default Dashboard;
